import { render, staticRenderFns } from "./CustomFitStlCanvas.vue?vue&type=template&id=39b8aba3&scoped=true&"
import script from "./CustomFitStlCanvas.vue?vue&type=script&lang=js&"
export * from "./CustomFitStlCanvas.vue?vue&type=script&lang=js&"
import style0 from "./CustomFitStlCanvas.vue?vue&type=style&index=0&id=39b8aba3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b8aba3",
  null
  
)

export default component.exports